import { extensions } from "@visiblethread/react-components";
import PropTypes, { number, oneOfType, string } from "prop-types";

export const VIRTUALIZE_TABLE = process.env.NODE_ENV !== "test";

// Pagination settings
export const ITEMS_PER_PAGE = 100;
export const INITIAL_PAGE = 1;
export const paginationProps = PropTypes.shape({
  numberOfItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  initialPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingConfig: PropTypes.shape({
    loading: PropTypes.bool,
    message: PropTypes.string,
  }),
});

export const DEFAULT_ERROR_MESSAGE =
  "There was an error completing the request";

export const USER_ROLES = {
  user: "user",
  dictionary: "dictionary",
  docStyleTemplates: "doc_style_templates",
  archiveStatuses: "archive_statuses",
  userAdmin: "user_admin",
  systemAdmin: "system_admin",
  readabilitySettings: "readability_settings",
  acronymSettings: "acronym_settings",
  discoverySettings: "discovery_settings",
  excelOutputs: "excel_outputs",
  proposalStages: "proposal_stages",
  editCurrencies: "edit_currencies",
};

export const PERMITTED_DOCUMENT_TYPES = [
  ".doc",
  ".docx",
  ".docm",
  ".pdf",
  ".xls",
  ".xlsx",
  ".xlsm",
  ".rtf",
];

// millis
export const INLINE_ALERT_TIMEMOUT = 5000;
export const POLL_TIMEOUT = 400;

export const MULTIPART_FORM_DATA_CONTENT_TYPE = "multipart/form-data";
export const URLENCODED_FORM_CONTENT_TYPE = "application/x-www-form-urlencoded";
export const JSON_CONTENT_TYPE = "application/json";
export const NAVIGATION_PANE = ".navigation_pane";

export const FILTER_CATEGORIES = {
  OPPORTUNITY_SEARCH: "opportunitySearch",
};

export const OPPORTUNITY_SEARCH_TYPE = {
  SAM_GOV: "samGov",
  EBUY: "ebuy",
  FIND_A_TENDER: "find-a-tender",
};

export const REPLACEMENT_RULES_REGEX = {
  OPPORTUNITY_NAME: /%opp_name%/gi,
};

export const ALLOWED_COLLECTIONS_EXTENSIONS = [
  extensions.doc,
  extensions.docx,
  extensions.docm,
  extensions.pdf,
];

export const ALLOWED_DOCUMENTS_EXTENSIONS = [
  extensions.doc,
  extensions.docx,
  extensions.docm,
  extensions.pdf,
  extensions.xls,
  extensions.xlsx,
  extensions.xlsm,
  extensions.rtf,
];

export const UNSUPPORTED_DOCUMENTS_ERROR = `Not supported. You can only upload file types: ${ALLOWED_DOCUMENTS_EXTENSIONS.map(
  (ext) => `.${ext}`
).join(",")}`;

export const idPropType = oneOfType([number, string]);

export const SAML_CONNECTION_SUCCESSFUL = "SAML_CONNECTION_SUCCESSFUL";

// Same-origin channel between the SSO test popup and the admin tab; unlike
// window.opener it survives blocked-popup recovery and COOP severing
export const SAML_TEST_CHANNEL = "saml-sso-test";

export const DEFAULT_SHAREPOINT_URL = "https://login.microsoftonline.com";
export const DEFAULT_GRAPH_URL = "https://graph.microsoft.com";
